import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, Loader2 } from "lucide-react";

/**
 * Post-setup transition screen shown AFTER PRO account setup
 * (credentials + recovery codes) and optional 2FA, BEFORE the inbox.
 * Auto-redirects to /pro/inbox after ~1.5s. Button bypasses the timer.
 */
export default function ProReadyScreen() {
  const navigate = useNavigate();
  const didRedirect = useRef(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (didRedirect.current) return;
      didRedirect.current = true;
      navigate("/pro/inbox", { replace: true });
    }, 1500);
    return () => clearTimeout(t);
  }, [navigate]);

  const goNow = () => {
    if (didRedirect.current) return;
    didRedirect.current = true;
    navigate("/pro/inbox", { replace: true });
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4" data-testid="pro-ready-screen">
      <div className="max-w-sm w-full text-center space-y-6">
        <div className="relative w-20 h-20 mx-auto">
          <div className="absolute inset-0 rounded-2xl bg-emerald-50 flex items-center justify-center">
            <CheckCircle2 size={36} className="text-emerald-600" strokeWidth={2} />
          </div>
        </div>
        <div>
          <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#111111]" data-testid="pro-ready-title">
            Your account is ready.
          </h1>
          <p className="mt-2 text-sm text-zinc-500" data-testid="pro-ready-subtitle">
            Your personal inbox has been successfully set up.
          </p>
        </div>
        <Button
          onClick={goNow}
          className="w-full h-11 bg-zinc-900 hover:bg-zinc-800 text-white"
          data-testid="pro-ready-go-btn"
        >
          Go to inbox <ArrowRight size={16} className="ml-2" />
        </Button>
        <div className="flex items-center justify-center gap-2 text-xs text-zinc-400">
          <Loader2 size={12} className="animate-spin" /> Redirecting you automatically
        </div>
      </div>
    </div>
  );
}
